
const PRODUCT_FEEDBACK = 'www.product.feedback';
const GLOBAL_PRODUCT_QUESTIONS_ANSWERS = 'www.product.feedback';
const GLOBAL_SIMILAR_PRODUCT_BY_GENDER = 'www.global.similar_product_by_gender';
const GLOBAL_PRODUCT_REVIEWS_DISPLAY_COMMENTS = 'www.global.reviews.product.display_comments';
const GLOBAL_WISHLIST = 'www.global.wishlist';
const PRODUCT_AVAILABILITY = 'www.product.product_availability';
const PAYPAL_OFFICIAL_WIDGET = 'www.global.paypal_official_widget';

export default defineNuxtPlugin((nuxtApp) => {
  const isFeatureEnabled = (featureName: string) => {
    const config = useRuntimeConfig();
    if (!config.public.featureFlags || config.public.featureFlags === '') {
      return false;
    }

    let featureFlags = config.public.featureFlags;

    if (typeof config.public.featureFlags !== 'string') {
      featureFlags = JSON.stringify(config.public.featureFlags)
    }

    featureFlags =  JSON.parse(featureFlags);
    const locale = useI18n().locale.value;
    let featureIsEnabled = false;

    Object.keys(featureFlags).forEach((flag) => {
      if (flag === featureName && featureFlags[flag][locale] === true) {
        featureIsEnabled = true;
      }
    })

    return featureIsEnabled;
  };

  nuxtApp.provide('isFeatureEnabled', isFeatureEnabled);
});

export {
  PRODUCT_FEEDBACK,
  GLOBAL_PRODUCT_QUESTIONS_ANSWERS,
  GLOBAL_SIMILAR_PRODUCT_BY_GENDER,
  GLOBAL_PRODUCT_REVIEWS_DISPLAY_COMMENTS,
  GLOBAL_WISHLIST,
  PRODUCT_AVAILABILITY,
  PAYPAL_OFFICIAL_WIDGET
}
